import {_get, _put, clubId} from "@api/doinsport/services/httpService";

const URL = 'clubs?network.id=';

export const getNetworkClubs = (id, search) => _get(URL + id + '&search=' + search);
